import { applicationState } from "shared/store/applicationState"
import { getAllDocumentTypes, getWritableDocumentTypes } from "./railDocumentsApi"
import { DocumentType as RailDocumentType } from "shared/models/site/document-type"
import { DocumentType } from "shared/models/api/models";

const mapper = (x: DocumentType): RailDocumentType => {
    return {
        key: x.name.replaceAll(' ', '').toLowerCase(),
        label: x.name,
        documentModule: x.documentModuleId,
        typeId: x.id,
        parentId: x.parentTypeId,
        documentTitleDefault: x.documentTitleDefault,
        documentTitleValidation: x.documentTitleValidation,
        documentNumberDefault: x.documentNumberDefault,
        documentNumberValidation: x.documentNumberValidation

    } as RailDocumentType;
}
// Load the document types into the app state
export const loadDocumentTypes = async () => {
    const docTypes = await getAllDocumentTypes();
    const mapped = docTypes
        .filter(x => (x.parentTypeId || 0) === 0)
        .map(x => (
            {
                ...mapper(x),
                children: docTypes.filter(dt => dt.parentTypeId === x.id).map(x => mapper(x))
            } as RailDocumentType));
    applicationState.setRailDocumentTypes(mapped);
    applicationState.setSearchableRailDocumentTypes(mapped);

    const writableDocTypes = await getWritableDocumentTypes();
    const writableMapped = writableDocTypes
        .filter(x => (x.parentTypeId || 0) === 0)
        .map(x => (
            {
                ...mapper(x),
                children: docTypes.filter(dt => dt.parentTypeId === x.id).map(x => mapper(x))
            } as RailDocumentType));
    applicationState.setWritableRailDocumentTypes(writableMapped);
}

// Given a document Id returns the root parent and the child item or parent and undefined if they are the same
export const getDocumentTypeFromId =
    (documentTypeId: number, items: Array<RailDocumentType>): RailDocumentType | undefined =>
        items.flatMap(x => x.children || []).find(x => x.typeId === documentTypeId)
        || items.find(x => x.typeId === documentTypeId)
